@if (productType !== 'GIRARDIN' || productType !== 'CAT') {
  <div class="row">
    @for (option of subsciptionOptions; track option; let i = $index) {
      <div
        class="col-md-6 mt"
        (click)="selectOption(option)"
        [ngClass]="option.maxSelected === maxSelected ? 'active' : ''"
      >
        <residence-box
          [suffix]="option.suffix"
          [title]="option.label"
          [svg]="option.svg"
        ></residence-box>
      </div>
    }
    @if (subsciptionOptions?.length === 1 && sessionConsultant) {
      <div class="col-md-6 mt" style="pointer-events: none">
        <residence-box
          suffix="B"
          title="Ajoutez le conjoint sur Albr.io pour la co-souscription"
          svg="tentant.svg"
        ></residence-box>
      </div>
    }
  </div>
}
